import React, { useEffect } from "react"
import { withTranslation } from "react-i18next"
import { graphql } from "gatsby"
import { renderBlocks } from "Utils/Helpers"
import PageTranslationSlugs from "Components/PageTranslationSlugs"
import Seo from "Components/Seo"

const translationSlugs = {
  us_en: "",
  us_es: "",
  ca_en: "",
  qc_en: "",
  qc_fr: "",
}

const Homepage = props => {
  const { data } = props

  useEffect(() => {
    let page = data?.page?.nodes?.[0]?.pageContext?.page
    if (!page) return

    // const {
    //   cf_assets: { scripts, cf_data },
    // } = page

    // loadAssets(`${scripts} ${cf_data}`, "cf_assets_container")
  }, [data?.page?.nodes])

  let page = data?.page?.nodes?.[0]?.pageContext?.page
  let blocks = page?.has_blocks

  return (
    <main>
      <Seo meta={page?.yoast_meta} page={page} />
      <PageTranslationSlugs translationSlugs={translationSlugs} />
      <div id="cf_assets_container" />
      {page && blocks && renderBlocks(page, { props })}
    </main>
  )
}

export default withTranslation()(Homepage)

export const pageQuery = graphql`
  query Homepage {
    page: allSitePage(filter: { id: { regex: "/us-en/homepage/" } }) {
      nodes {
        id
        path
        pageContext
      }
    }
  }
`
